<template>
  <div class="bp-dropdown">
    <bp-dropdown-popper
      trigger="clickToToggle"
      :disabled="disabled"
      :options="popperOptions"
    >
      <div slot="reference" ref="toggle" @click.prevent.stop>
        <snow-button
          size="sm"
          variant="borderless"
          icon="ph ph-dots-three"
          :disabled="disabled"
        />
      </div>

      <div class="bp-dropdown-options" slot="default">
        <slot>
          <snow-dropdown-item
            v-for="(option, index) in actions"
            v-bind="option"
            :customClass="option.class"
            :key="index"
            @toggle="toggle"
            @event="e => $emit(e)"
          />
        </slot>
      </div>
    </bp-dropdown-popper>
  </div>
</template>
<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
import SnowDropdownItem from "@/components/snow-ui/SnowDropdownItem.vue";
export default {
  components: { "bp-dropdown-popper": Popper, SnowDropdownItem },
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    popperOptions() {
      return {
        placement: "left",
        modifiers: {
          offset: {
            offset: "0,10px"
          }
        }
      };
    }
  },
  methods: {
    toggle() {
      this.$refs.toggle.click();
    }
  }
};
</script>
<style lang="scss">
.bp-dropdown {
  .bp-dropdown-options {
    padding: 16px;
    border-radius: 16px;
    backdrop-filter: blur(20px);
    background: var(--bg-1);
    border: 1px solid var(--dark-10);
    z-index: 100000;
    max-width: 200px;
    width: max-content;

    display: flex;
    flex-direction: column;
  }
}
</style>
